export const scrollToElement = (id: string, duration = 1000): void => {
    const element = document.getElementById(id);
    if (!element) return;

    const startPosition = window.scrollY;
    let startTime: number | null = null;

    const animation = (currentTime: number) => {
        if (!startTime) startTime = currentTime;
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Recalculate target each frame so expanding accordion content is accounted for
        const currentTargetPosition = element.getBoundingClientRect().top + window.scrollY;
        const currentDistance = currentTargetPosition - startPosition;

        window.scrollTo(0, startPosition + currentDistance * progress);
        if (elapsed < duration) requestAnimationFrame(animation);
    };

    requestAnimationFrame(animation);
};
